<template>
<!-- 邀请语列表 -->
    <div class="el-card  pd20">
        <!-- add---新增 -->
        <div class="box">
            <router-link to="/main/invite_form">
                <el-button type="primary" size="medium">新增邀请语</el-button>
            </router-link>
            <!--  --> 
            <div class="search">
                关联课程
                <el-select class="search-child" v-model="course_id" placeholder="请选择关联课程" clearable>
                    <el-option  v-for="(item,index) in course_list" :key="index" :label="item.name" :value="item.id">{{item.name}}</el-option>
                </el-select>
                <!-- 搜索 -->
                <el-button type="primary" class="search-child btn" @click="pullData" round  size="medium">搜索</el-button>
            </div>
            
        </div>
        <!--  -->
        <div class="el-card  pd20 content">
            <el-table :data="list" border style="width: 100%">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column type="index" width="80" label="序号"></el-table-column>
                <el-table-column prop="name"  label="课程名称"></el-table-column>
                <!-- <el-table-column label="课程名称" >
                    <template slot-scope="scope"> -->
                        <!-- 因为for比if先执行，所以循环判断是否相等，如果相等显示课程名称 -->
                        <!-- <span v-if="item.id == scope.row.course_id" v-for="(item,index) in course_list" :key="index">{{item.name}}</span>
                    </template>
                </el-table-column> -->
                <el-table-column prop="describe" label="海报描述" > </el-table-column>

                <el-table-column prop="describe" label="内容" > </el-table-column>
                <el-table-column prop="headsize" label="状态" >
                    <template slot-scope="scope">
                        <el-tag size="small" v-if="scope.row.state==0" type="success">开启</el-tag>
                        <el-tag size="small" v-if="scope.row.state==1" type="info">关闭</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="create_time" label="创建时间" > </el-table-column>
                <el-table-column prop="update_time" label="更新时间" > </el-table-column>
                <el-table-column  label="操作" >
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" icon="el-icon-edit" @click="edit(scope.$index, scope.row,'edit')" circle></el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination class="pages" 
                :page-sizes="[25, 50, 75, 100]"
                @size-change="handleSizeChange" 
                @current-change="handleCurrentChange" 
                :page-size="pages.size" 
                :current-page="pages.page"
                background 
                layout="sizes,prev, pager, next" 
                :total="pages.count"> 
            </el-pagination>
        </div>
    </div>
</template>

<script>
import { inviteList,missionCamp } from "@/api/operating";
export default {
    data() {
        return{
            pages:{},
            list:[],
            // 
            course_id:null,
            course_list:[],
            obj:{}
        }
    },
    methods:{
        edit(index,row){
            this.$router.push({
                path:'/main/invite_form',
                query:{
                    id:row.id,
                    type:'edit'
                }
            });
        },
         // 调整每页显示条数
        handleSizeChange(val) {
            this.pages.size = val;
            this.pullData();
        },
        // 触发分页
        handleCurrentChange(val) {
            this.pages.page = val;
            this.pullData();
        },
        pullData(){
            this.$showLoading();
            
            this.obj = {
                page:Object.keys(this.pages).length>0?this.pages.page:1,  //页码，默认1
                size:Object.keys(this.pages).length>0?this.pages.size:25   //每页数量，默认25
            };
            if(this.course_id !==null){
                this.obj['course_id'] = this.course_id;
            }

            let arr1 =  inviteList(this.obj);

            let arr2 =  missionCamp();

            Promise.all([arr1,arr2]).then((data)=>{
                this.list = data[0].list;
                this.pages = data[0].pager;

                // 
                this.course_list = data[1].list;

                this.$hideLoading();
            }).catch((err)=>{
                this.$hideLoading();
            });
        }
    },
    created(){
        this.pullData();
    }
}
</script>

<style lang="scss" scoped>
.headimgurl{
    width: 100px;
    height: 100px;
}
.box{
    margin-bottom: 20px;
    display: flex;
}
.content{
    padding: 20px;
}
.pages{
  text-align: right;
  margin-top: 30px;
}
.search{
    text-align: right;
    display: flex;
    align-items: center;
    margin-left: auto;
}
.search-child{
    width: auto;
    margin-left: 20px;
}
.search-child.btn{
    margin-left: 20px;
}
.table-img{
    width: 100%;
}
</style>
